(function(window, document, $) {
	"use strict";

	var cookieInformation = {
		init: function() {
			var $cookieInfoContainer = $('.cookie-information-container');
			var $body = $('body');
			if ($cookieInfoContainer.length > 0) {
				if (!localStorage.hasOwnProperty('var_readCookieInfo')) {
					$body.addClass('cookie-info-active');
				}

				$cookieInfoContainer.find('.btn').on('click', function() {
					localStorage.var_readCookieInfo = true;
					$body.removeClass('cookie-info-active');
				});
			}
		}
	}
	
	$(document).ready( function(){
		cookieInformation.init();
	});

})(window, document, jQuery);
